export const user = (state) => state.user

export const roles = (state) => state.roles

export const registerProviders = (state) => state.registerProviders
